import { TableCell, TableHead, TableRow } from "@mui/material";

import HNSColors from "../../../../../ui library/HNSColors";

const HEADER_CELLS = ["Status", "Start Date", "End Date", "Updated By"];

export default function NetworkSettingsHistoryTableHeader() {
  return (
    <TableHead>
      <TableRow>
        {HEADER_CELLS.map((header) => (
          <TableCell
            key={header}
            sx={{
              color: HNSColors.neutrals[400],
              fontSize: 14,
              fontWeight: 400,
              borderBottomColor: HNSColors.neutrals[700],
              paddingTop: 0,
              paddingBottom: 1.5,
              paddingLeft: 0,
              paddingRight: 2,
            }}
          >
            {header}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}
